import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  background: (p) => p.palette.grey[200],
  p: 1.5,
  borderRadius: 1,
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const label: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
};

export const button: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  borderRadius: 0.5,
  py: 0,
};

export const textfield: SxStyle = {
  flex: 1,
  '.MuiInputBase-root': {
    borderRadius: 0.5,
  },
  input: {
    background: (p) => p.palette.common.white,
    overflow: 'hidden',
    borderRadius: 0.5,
    fontSize: (p) => p.typography.caption.fontSize,
  },
};
